// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"tb_a bic_rc bic_qx bic_xr","ContestPosts__more":"tb_b bic_vu bic_b bic_va bic_sv"};